import amplitudeConfig from '@config/amplitude.json'

import { trackClassroomEvent } from '@tools/amplitude/classroom'

interface LessonRoomAnalyticsReturn {
  trackConnected: (props?: Record<string, any>) => void
  trackDisconnected: (props?: Record<string, any>) => void
  trackClickMic: (props?: Record<string, any>) => void
  trackClickCam: (props?: Record<string, any>) => void
  trackClickShare: (props?: Record<string, any>) => void
  trackPageView: (roomType: string) => void
  trackClickSettings: () => void
  trackSelectMicro: (deviceId: string) => void
  trackSelectCamera: (deviceId: string) => void
  trackSelectSpeaker: (deviceId: string) => void
  trackClickGuide: () => void
}

export const useLessonRoomAnalytics = (): LessonRoomAnalyticsReturn => ({
  trackConnected: (props = {}) => trackClassroomEvent(amplitudeConfig.events.userConnected, props),
  trackDisconnected: (props = {}) => trackClassroomEvent(amplitudeConfig.events.userDisconnected, props),
  trackClickMic: (props = {}) => trackClassroomEvent(amplitudeConfig.events.clickMic, props),
  trackClickCam: (props = {}) => trackClassroomEvent(amplitudeConfig.events.clickCam, props),
  trackClickShare: (props = {}) => trackClassroomEvent(amplitudeConfig.events.clickShare, props),
  trackPageView: (roomType) => trackClassroomEvent(amplitudeConfig.events.pageViewLesson, { room_type: roomType }),
  trackClickSettings: () => trackClassroomEvent(amplitudeConfig.events.clickSettings),
  trackSelectMicro: (deviceId) => trackClassroomEvent(amplitudeConfig.events.selectMicro, { device_id: deviceId }),
  trackSelectCamera: (deviceId) => trackClassroomEvent(amplitudeConfig.events.selectCamera, { device_id: deviceId }),
  trackSelectSpeaker: (deviceId) => trackClassroomEvent(amplitudeConfig.events.selectSpeaker, { device_id: deviceId }),
  trackClickGuide: () => trackClassroomEvent(amplitudeConfig.events.clickGuide),
})
